import { ActionCardComponent } from './components/action-card/action-card.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { NgSelectModule } from '@ng-select/ng-select';
import { AuthHeaderComponent } from './components/auth-header/auth-header.component';
import { FooterComponent } from './components/footer/footer.component';
import { CustomHeaderComponent } from './components/custom-header/custom-header.component';
import { CardComponent } from './components/card/card.component';
import { EditArterialComponent } from './components/edit-arterial/edit-arterial.component';
import { EditEnduranceComponent } from './components/edit-endurance/edit-endurance.component';
import { EditCvcComponent } from './components/edit-cvc/edit-cvc.component';
import { EditMidlinesComponent } from './components/edit-midlines/edit-midlines.component';
import { G4PiccComponent } from './components/g4-picc/g4-picc.component';
import { EditRhythmComponent } from './components/edit-rhythm/edit-rhythm.component';
import { TableFilterComponent } from './components/table-filter/table-filter.component';

@NgModule({
  declarations: [
    AuthHeaderComponent,
    FooterComponent,
    CustomHeaderComponent,
    CardComponent,
    ActionCardComponent,
    EditArterialComponent,
    EditEnduranceComponent,
    EditCvcComponent,
    EditMidlinesComponent,
    G4PiccComponent,
    EditRhythmComponent,
    TableFilterComponent
  ],
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, NgSelectModule],
  exports: [
    AuthHeaderComponent,
    FooterComponent,
    CustomHeaderComponent,
    CardComponent,
    ActionCardComponent,
    EditArterialComponent,
    EditArterialComponent,
    EditCvcComponent,
    EditMidlinesComponent,
    G4PiccComponent,
    EditRhythmComponent,
    TableFilterComponent,
    NgSelectModule
  ],
})
export class SharedModule {}
